<script setup>
const props = defineProps({
  url: {
    type: String,
    default: '',
    required: true,
  },
  routerLink: Boolean,
  v2Link: {
    type: Boolean,
    default: true,
  },
  applyCurrentProviderPrefix: {
    type: Boolean,
    default: true,
  },
})

const { r } = useRoutes()
const { sessionData } = useSessionData()
const ignoreRouterLink = toRef(sessionData.ignoreRouterLink)

const computedUrl = computed(() => {
  return r({ path: props.url, isV2Path: props.v2Link, applyCurrentProviderPrefix: props.applyCurrentProviderPrefix })
})
const isComponentRouterLink = computed(() => (props.routerLink && !ignoreRouterLink.value))
</script>

<template>
  <component
    :is="isComponentRouterLink ? 'router-link' : 'a'"
    class="cursor-pointer"
    :to="isComponentRouterLink ? computedUrl : undefined"
    :href="computedUrl"
  >
    <slot />
  </component>
</template>
